const addBy = (field) => (array) =>
	(Array.isArray(array) ? array : []).reduce((o, x) => o + x[field], 0)

export const calculateTotal = addBy('total')
export const calculateTotalDiscount = addBy('totalDiscount')
